<template>
  <div class="container-box">
    <el-table :data="info.transactionVos" border size="mini" max-height="350px">
      <el-table-column prop="type" label="交易类型" align="center" width="70" />
      <el-table-column prop="trxId" label="商户单号" align="center" width="200" />
      <el-table-column prop="ydTrxId" label="交易单号" align="center" width="130" />
      <el-table-column prop="detail" label="交易明细" align="center">
        <template slot-scope="scope">
          <div v-for="(item, i) in scope.row.detail" :key="i">
            <div>{{ item }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="payAmount" label="金额" align="center" />
      <el-table-column prop="operatingEnter" label="操作入口" align="center" />
      <el-table-column prop="time" label="时间" align="center" />
      <el-table-column prop="status" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="getDetail(scope.row.ydTrxId, scope.row.type)">
            查询
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      append-to-body="“true”"
      :title="transactionDetail.title"
      center
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <div class="title">交易状态：{{ transactionDetail.transactionStatus }}</div>
      <div v-if="transactionDetail.errorMsg" class="title"
        >失败原因：{{ transactionDetail.errorMsg }}</div
      >
      <div class="title">借贷标识：{{ transactionDetail.borrowingFlag }}</div>
      <div class="title">交易完成时间：{{ transactionDetail.finishTime }}</div>
      <div class="title">交易金额：{{ transactionDetail.transactionAmount }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">返 回</el-button>
        <el-button v-if="isButtonAvailable" type="primary" @click="handleThirdRefund"
          >三方退款</el-button
        >
        <el-button v-else type="primary" @click="dialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { queryTransactionDetail, thirdRefund } from '@/api/intercityorder'
  export default {
    name: 'transactionInfo',
    props: {
      info: {}
    },
    data() {
      return {
        dialogVisible: false,
        transactionDetail: [],
        payNo: '',
        isButtonAvailable: false
      }
    },
    mounted() {
      console.log(this.info)
    },
    methods: {
      getDetail(transactionOrderNo, transactionType) {
        this.payNo = transactionOrderNo
        const loading = this.$loading({})
        queryTransactionDetail(transactionOrderNo, transactionType).then((res) => {
          const { data, code } = res
          if (code === 0) {
            loading.close()
            this.dialogVisible = true
            this.transactionDetail = data
            if (this.transactionDetail.isButtonAvailable && this.info.transactionType === '退款') {
              this.isButtonAvailable = true
            }
          } else {
            loading.close()
            // this.$message.error(msg)
          }
        })
      },
      handleThirdRefund() {
        const params = {
          buOrigin: this.transactionDetail.businessOrigin,
          payNo: this.payNo,
          refundAmount: this.transactionDetail.transactionAmount
        }
        thirdRefund(params).then((res) => {
          const loading = this.$loading({})
          const { code, msg } = res
          if (code === 0) {
            loading.close()
          } else {
            this.$message.error(msg)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0 30px 0;
    padding: 0 10px;
    z-index: 999999;
  }
  .title {
    margin-bottom: 10px;
  }
</style>
